import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout from "./Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Team from "./pages/Team";
import SuccessPage from "./pages/SuccessPage";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />{" "}
        <Route path="/services" element={<Services />} />{" "}
        <Route path="/gallery" element={<Gallery />} />{" "}
        <Route path="/team" element={<Team />} />{" "}
        <Route path="/contact" element={<Contact />} />{" "}
        <Route path="/success" element={<SuccessPage />} />{" "}
        <Route path="/terms-of-service" element={<TermsOfService />} />{" "}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />{" "}
      </Route>{" "}
    </Routes>
  );
}
